document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('main .shopify-section');

  if (!sections.length) return;

  document.documentElement.classList.add('kiekeboe-reveal-ready');

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kiekeboe-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: "0px 0px -12% 0px"
    }
  );

  sections.forEach(function (section) {
    const rect = section.getBoundingClientRect();

    if (rect.top < window.innerHeight * .88) {
      section.classList.add('kiekeboe-visible');
    } else {
      observer.observe(section);
    }
  });
});